/**
 * Content 타입별 정보 스키마 (공통)
 *
 * Backend의 UserContentCreateInfoDto와 동일한 구조
 * VideoCreateDto, AudioCreateDto, ImageCreateDto, FontCreateDto에 대응
 */
import { z } from 'zod';

// ===================================
// Content 타입별 스키마
// ===================================

export const VideoContentSchema = z.object({
  type: z.literal('VIDEO'),
  /** 재생 시간 (필수, ms) */
  duration: z.number(),
  /** Resolution enum 코드 (0: AUTO, 1: FHD, 2: HD, 3: SD) */
  resolution: z.number().default(0),
  /** 영상 너비 (optional, 기본값 0) */
  width: z.number().default(0),
  /** 영상 높이 (optional, 기본값 0) */
  height: z.number().default(0),
});

export const AudioContentSchema = z.object({
  type: z.literal('AUDIO'),
  /** 재생 시간 (필수, ms) */
  duration: z.number(),
});

export const ImageContentSchema = z.object({
  type: z.literal('IMAGE'),
  /** 이미지 너비 (필수) */
  width: z.number(),
  /** 이미지 높이 (필수) */
  height: z.number(),
});

export const FontContentSchema = z.object({
  type: z.literal('FONT'),
});

export const DocumentContentSchema = z.object({
  type: z.literal('DOCUMENT'),
});

// ===================================
// discriminatedUnion으로 Backend와 동일한 다형성 처리
// ===================================

export const ContentInfoSchema = z.discriminatedUnion('type', [
  VideoContentSchema,
  AudioContentSchema,
  ImageContentSchema,
  FontContentSchema,
  DocumentContentSchema,
]);

// ===================================
// Type exports
// ===================================

export type VideoContentType = z.infer<typeof VideoContentSchema>;
export type AudioContentType = z.infer<typeof AudioContentSchema>;
export type ImageContentType = z.infer<typeof ImageContentSchema>;
export type FontContentType = z.infer<typeof FontContentSchema>;
export type DocumentContentType = z.infer<typeof DocumentContentSchema>;
export type ContentInfoType = z.infer<typeof ContentInfoSchema>;
